import { NgModule } from '@angular/core';
import { IsNotEmptyStringPipe } from './is-not-empty-string.pipe';



@NgModule({
  declarations: [
    IsNotEmptyStringPipe
  ],
  exports: [
    IsNotEmptyStringPipe
  ]
})
export class IsNotEmptyStringModule { }
